import { getLogger } from "@expert/logging";

import { getRootDispatcher } from "@/analytics";
import { getGamificationApiClient } from "@/sales-tools/api/api";

import type { PayMetrics } from "./types";

const logger = getLogger({ module: "getPayMetrics" });

function isPayMetrics(data: unknown): data is PayMetrics {
    if (typeof data !== "object" || data === null) return false;
    const obj = data as Record<string, unknown>;
    if (!("totals" in obj)) return false;
    const totals = obj.totals;
    if (typeof totals !== "object" || totals === null) return false;
    return "serve" in totals && "solve" in totals && "sell" in totals;
}

export const getPayMetrics = async (): Promise<PayMetrics | null> => {
    const resp: unknown = await getGamificationApiClient().get("v1/pay-metrics").json();

    if (!isPayMetrics(resp)) {
        logger.warn(
            { responseKeys: resp ? Object.keys(resp as object) : null },
            "Off-call hub: pay-metrics API response did not match expected shape",
        );
        return null;
    }

    void getRootDispatcher().dispatchBusinessEvent("PayMetricsReceived", {
        hasServe: Object.keys(resp.totals.serve).length > 0,
        hasSolve: Object.keys(resp.totals.solve).length > 0,
        hasSell: Object.keys(resp.totals.sell).length > 0,
    });

    return resp;
};
